import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
// PostHog temporarily disabled to resolve CORS/security scan issues
// import posthog from 'posthog-js';
// if (process.env.REACT_APP_POSTHOG_KEY) {
//   posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
//     api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
//     person_profiles: 'identified_only',
//     loaded: (posthog) => {
//       if (process.env.NODE_ENV === 'development') posthog.debug();
//     },
//   });
// }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
